import isPlainObject from 'lodash/isPlainObject.js';
import isDate from 'lodash/isDate.js';
import { datesAreEqual, pageForDate, getMaxPage, addPages } from '../helpers.js';
import DateInfo, { addDays } from '../date-info.js';

class RangePicker {
  constructor(_ref) {
    let {
      locale,
      format,
      parse
    } = _ref;
    Object.assign(this, {
      locale,
      format,
      parse
    });
  }
  hasValue(value) {
    return isPlainObject(value) && isDate(value.start) && isDate(value.end);
  }
  normalize(value) {
    if (!this.hasValue(value)) {
      return null;
    }
    const {
      start,
      end
    } = new DateInfo({
      start: new Date(value.start),
      end: new Date(value.end)
    }, {
      locale: this.locale
    });
    return {
      start,
      end
    };
  }
  formatValue(value) {
    const nValue = this.normalize(value);
    if (!nValue) {
      return '';
    }
    const {
      start,
      end
    } = nValue;
    const startText = this.format(start);
    const endText = this.format(end);
    if (!startText || !endText) {
      return '';
    }
    return `${startText} - ${endText}`;
  }
  parseValue(text) {
    let start;
    let end;
    const dateTexts = text.split('-').map(s => s.trim());
    if (dateTexts.length >= 2) {
      start = this.parse(dateTexts[0]);
      end = this.parse(dateTexts[1]);
    }
    return start && end ? this.normalize({
      start,
      end
    }) : null;
  }
  filterDisabled(_ref2) {
    let {
      value,
      isRequired,
      disabled,
      fallbackValue
    } = _ref2;
    let newValue = isRequired ? fallbackValue : null;
    if (this.hasValue(value) && (!disabled || !disabled.intersectsDate(value))) {
      newValue = value;
    }
    return newValue;
  }
  valuesAreEqual(a, b) {
    const aHasValue = this.hasValue(a);
    const bHasValue = this.hasValue(b);
    if (!aHasValue && !bHasValue) {
      return true;
    }
    if (aHasValue !== bHasValue) {
      return false;
    }
    return datesAreEqual(a.start, b.start) && datesAreEqual(a.end, b.end);
  }
  getPageRange(value) {
    if (!this.hasValue(value)) {
      return null;
    }
    const from = pageForDate(value.start);
    const to = getMaxPage(pageForDate(value.end), addPages(from, 1));
    return {
      from,
      to
    };
  }
  parseShortcutValue(value) {
    if (isDate(value.start) && isDate(value.end)) {
      return this.normalize(value);
    }
    return this.normalize({
      start: addDays(new Date(), value.start),
      end: addDays(new Date(), value.end)
    });
  }
  handleDayClick(day, picker) {
    const {
      dateTime
    } = day;
    if (!picker.dragValue) {
      const newDragValue = {
        start: new Date(dateTime),
        end: new Date(dateTime)
      };
      if (picker.dateIsValid(newDragValue)) {
        picker.dragValue = newDragValue;
      }
    } else {
      const value = this.normalize({
        start: new Date(picker.dragValue.start.getTime()),
        end: new Date(dateTime)
      });
      if (picker.dateIsValid(value)) {
        picker.dragValue = null;
        picker.model = value;
        picker.$emit('select-date', {
          value
        });
      }
    }
  }
  handleShortcutSelect(shortcut, picker) {
    if (picker.dateIsValid(shortcut.value)) {
      picker.dragValue = null;
      picker.model = shortcut.value;
    }
  }
  handleDayMouseEnter(day, picker) {
    const {
      dateTime
    } = day;
    if (picker.dragValue) {
      const newDragValue = {
        start: new Date(picker.dragValue.start.getTime()),
        end: new Date(dateTime)
      };
      if (picker.dateIsValid(newDragValue)) {
        picker.dragValue = newDragValue;
      }
    }
  }
}

export { RangePicker as default };
//# sourceMappingURL=range.js.map
